// API base URLs. Production defaults target the first-party aquinocompliance.com stack (SPA + workers
// share the registrable domain → first-party httpOnly session cookie in every browser). Override with
// VITE_* vars. PLAN-C1.11.
export const API_BASE = {
  tenant: import.meta.env.VITE_TENANT_API ?? "https://api.aquinocompliance.com",
  admin: import.meta.env.VITE_ADMIN_API ?? "https://admin-api.aquinocompliance.com",
  mcp: import.meta.env.VITE_MCP_API ?? "https://mcp.aquinocompliance.com",
  // Cross-tenant consultancy cockpit API (B5B-PARTNER-COCKPIT / C4.1).
  cockpit: import.meta.env.VITE_COCKPIT_API ?? "https://cockpit.aquinocompliance.com",
} as const;

/** The auth-worker (identity broker) — login / callback / me / logout. PLAN-C1.3. */
export const AUTH_BASE = import.meta.env.VITE_AUTH_BASE_URL ?? "https://auth.aquinocompliance.com";

/** Canonical production origin for this SPA (legacy *.pages.dev URLs forward here so the session
 *  cookie stays first-party). */
export const APP_ORIGIN = import.meta.env.VITE_APP_ORIGIN ?? "https://partners.aquinocompliance.com";
